import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

//年月日过滤器
Vue.filter('YMD', function (dataStr, pattern = 'YYYY-MM-DD') {
  return moment(dataStr).format(pattern)
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

//字典过滤器
Vue.filter('DICT', function (record, dictList) {
  let result = '', newRecord = ''
  try {
    newRecord = JSON.parse(record);
  } catch (error) {
    newRecord
  }
  //如果是多选数组
  if (newRecord.length > 1) {
    newRecord.forEach(item => {
      let label = dictList.find(x => x.dictCode === item).dictValue
      if (label) {
        result += label + ','
      }
    })
    result = result.substring(0, result.lastIndexOf(','));
  } else {
    //只有单一值
    let label = dictList.find(x => x.dictCode === record || x.dictCode === newRecord[0])
    if (label) {
      result = label.dictValue
    }
  }
  return result
})